
    import { Component, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import ErinnerungenDatatable from '@/components/Impfverwaltung/Erinnerungen/ErinnerungenDatatable.vue';
    import Impferinnerung from '@/types/Impferinnerung';

    @Component({
        components: {
            ErinnerungenDatatable,
        },
        computed: {
            ...mapState('patient', ['patientData', 'loaders', 'erinnerungen']),
        },
    })
    export default class ErinnerungenTabitem extends Vue {
        public selected: Impferinnerung[] = [];

        public reset(): void {
            this.selected = [];
        }
    }
